import { isCategoryInRange, isCodeInDottedRange } from "./normalise";

/** The ICD-10 positions a listed co-morbidity should land inside, after the episode codes. */
export const MANDATORY_COMORBIDITY_WINDOW = 20;

// Custom list combining NCCS Appendix 1 and Charlson codes.
// Row order is the priority order; the first entry is rank 1.
export const MANDATORY_COMORBIDITY_RANGES: ReadonlyArray<readonly [from: string, to: string]> = [
  ["B20", "B24"],
  ["C77", "C80"],
  ["I85", "I85"],
  ["I86.4", "I86.4"],
  ["I98.2", "I98.2"],
  ["K70", "K74"],
  ["K76", "K76"],
  ["C00", "C76"],
  ["C81", "C97"],
  ["E10", "E14"],
  ["G04.1", "G04.1"],
  ["G10", "G13"],
  ["G80.0", "G80.2"],
  ["G81", "G82"],
  ["G83.0", "G83.4"],
  ["G83.8", "G83.9"],
  ["I10", "I15"],
  ["N03", "N03"],
  ["N05", "N05"],
  ["N11", "N12"],
  ["N18", "N19"],
  ["N25.0", "N25.0"],
  ["Z49.0", "Z49.2"],
  ["Z94", "Z94"],
  ["Z99.2", "Z99.2"],
  ["B18", "B18"],
  ["F00", "F03"],
  ["G30", "G32"],
  ["G45", "G46"],
  ["H34.0", "H34.0"],
  ["I09.9", "I09.9"],
  ["I25", "I25"],
  ["I27.8", "I27.9"],
  ["I42", "I45"],
  ["I47", "I50"],
  ["I65", "I69"],
  ["I70", "I71"],
  ["I73.1", "I73.1"],
  ["I73.8", "I73.9"],
  ["I77.1", "I77.1"],
  ["I79.0", "I79.0"],
  ["I79.2", "I79.2"],
  ["J40", "J45"],
  ["J47", "J47"],
  ["J60", "J67"],
  ["J68.4", "J68.4"],
  ["J70.1", "J70.1"],
  ["J70.3", "J70.3"],
  ["K25", "K28"],
  ["K55.1", "K55.1"],
  ["K55.8", "K55.9"],
  ["M05", "M09"],
  ["M30", "M36"],
  ["Z95.8", "Z95.9"],
  ["D65", "D68"],
  ["D69.1", "D69.1"],
  ["D69.3", "D69.6"],
  ["D73.0", "D73.0"],
  ["D80", "D89"],
  ["E66", "E66"],
  ["E84", "E84"],
  ["F06.4", "F06.4"],
  ["F10", "F19"],
  ["F20", "F29"],
  ["F30.2", "F30.2"],
  ["F31", "F33"],
  ["F34.1", "F34.1"],
  ["F40", "F41"],
  ["F43.2", "F43.2"],
  ["F50", "F50"],
  ["F70", "F79"],
  ["F84", "F84"],
  ["F93.1", "F93.2"],
  ["F93.8", "F93.8"],
  ["F94.0", "F94.0"],
  ["G20", "G22"],
  ["G35", "G35"],
  ["G40", "G40"],
  ["G71.0", "G71.0"],
  ["H54.0", "H54.1"],
  ["H54.4", "H54.5"],
  ["I20", "I20"],
  ["I27.0", "I27.0"],
  ["I27.2", "I27.2"],
  ["J84", "J84"],
  ["J96.1", "J96.1"],
  ["K90.0", "K90.0"],
  ["M45", "M45"],
  ["M46.8", "M46.9"],
  ["N27", "N27"],
  ["Q24", "Q24"],
  ["Q61", "Q61"],
  ["Q89.0", "Q89.0"],
  ["Q90", "Q99"],
  ["Z21", "Z21"],
  ["Z92.1", "Z92.1"],
  ["Z95.0", "Z95.0"],
  ["Z95.2", "Z95.4"],
];

const matcherFor = ([from, to]: readonly [string, string]) =>
  from.includes(".")
    ? (code: string) => isCodeInDottedRange(code, from, to)
    : (code: string) => isCategoryInRange(code, from.slice(0, 1), Number(from.slice(1)), Number(to.slice(1)));

const MATCHERS = MANDATORY_COMORBIDITY_RANGES.map(matcherFor);

/** The 1-based row of the mandatory co-morbidity list that covers `code`, or `undefined` if none does. A code in several rows takes the lowest. */
export const mandatoryComorbidityRank = (code: string): number | undefined => {
  const index = MATCHERS.findIndex((matches) => matches(code));

  return index === -1 ? undefined : index + 1;
};
